import { WSTable, WSTableItem } from "@wingspanhq/fe-component-library";
import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import { getColumnsContractor } from "./columns";

type Props = {
  items: PayrollRun[];
  loading?: boolean;
  onRowOpen?: (id: string) => void;
};

/**
 * The Payables "Payroll Runs" table, kept in the shape of the retired v1
 * screen: four columns, a row that opens the run on click, and nothing else —
 * no filters, no export action, no per-row menu. The dedicated payroll-runs
 * module has its own table (`TablePayrollsEmployee`) built to the new design;
 * the two are separate on purpose and share no layout.
 */
export const TablePayrollsContractor: React.FC<Props> = props => {
  const tableData = useMemo<WSTableItem<PayrollRun>[]>(
    () => props.items.map(item => ({ id: item.id ?? "", data: item })),
    [props.items]
  );
  const columns = useMemo(() => getColumnsContractor(), []);

  return (
    <WSTable<PayrollRun>
      columns={columns}
      loading={props.loading}
      tableData={tableData}
      onRowClick={item => props.onRowOpen?.(item.id)}
    />
  );
};
